import React from 'react'
import { IoMdRefresh } from 'react-icons/io'
import { FiSend } from 'react-icons/fi'
import { BsFillJournalBookmarkFill } from 'react-icons/bs'
import { Spinners } from '../../components/TableOptions'


const TestScore = ({ incrementCountCancel, calculateScore, handleSendTest, sendTestisLoading, id }: any) => {

	// @ts-ignore  
	const success = JSON.parse(localStorage.getItem(id.toString()));

	const handleFinished = () => {
		window.location.replace(`/test/thankyou/${id}`)
		localStorage.removeItem(id.toString())


	}



	return (
		<div className='quizeanswer'>
			{success === false || success === null ? <div>
				<h3> Do you want to submit?</h3>
				<div className="scoreBoard">
					<span className="scoreCount"> <BsFillJournalBookmarkFill size={50} color='green' /></span>
					<button className="btn" onClick={incrementCountCancel}>
						<IoMdRefresh /> Again </button>
					<span className='m-2' />

					<button className="btn" onClick={handleSendTest}>
						{sendTestisLoading ? <Spinners size={"sm"} /> : <span><FiSend /> Submit </span>}
					</button>

				</div>
			</div> : <div>
				<h3>Your scored</h3>
				<div className="scoreBoard">
					<span className="scoreCount">{calculateScore()}</span>
					<button className="btn" onClick={handleFinished}>
						Finish </button>
				</div>
			</div>}

		</div>
	)
}

export default TestScore
